import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "chat-messages-panel__messages-block-logo-img",
  alt: "Avatar"
}
const _hoisted_3 = {
  key: 1,
  class: "chat-messages-panel__messages-block-logo-text"
}
const _hoisted_4 = { class: "body-header" }
const _hoisted_5 = { class: "body-header__title" }
const _hoisted_6 = { class: "body-header__title-name" }
const _hoisted_7 = { class: "body-header__title-date" }
const _hoisted_8 = { class: "body-message" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "body-message__attacheds"
}

import {ChatMessage, ChatModes} from "@/store/chats";
import moment from "moment/moment";
import ChatMessageAttached from "@/components/main/chat-panel/ChatMessageAttached.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
    message: {},
    mode: {},
    selected: { type: Boolean }
  },
  emits: ["set-answered"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const getDialogDate = (date: string) => moment(date).format("DD.MM.YYYY HH:mm");

return (_ctx: any,_cache: any) => {
  const _directive_img_fade = _resolveDirective("img-fade")!

  return (_openBlock(), _createElementBlock("div", {
    id: `message-${props.message.Id}`,
    class: _normalizeClass({
			'chat-messages-panel__messages-block': true,
			'chat-messages-panel__messages-block--searched': props.mode === 'search-messages'
		})
  }, [
    (props.message.PhotoLink)
      ? _withDirectives((_openBlock(), _createElementBlock("img", _hoisted_2, null, 512)), [
          [_directive_img_fade, props.message.PhotoLink]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.message.PhotoLiter), 1)),
    _createElementVNode("div", {
      class: _normalizeClass({
				'chat-messages-panel__messages-block-body': true,
				'chat-messages-panel__messages-block-body--selected': props.selected,
				'chat-messages-panel__messages-block-body--unreaded': props.message.Unreaded,
			})
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(props.message.WorkerName), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(getDialogDate(props.message.Date)), 1)
        ]),
        _createVNode(AppTooltip, { text: "Ответить" }, {
          activator: _withCtx(() => [
            _createVNode(AppIcon, {
              class: "body-header__icon-reply",
              name: "reply-left",
              width: "14px",
              color: "#D2D2D2",
              "hover-color": "#3F884F",
              cursor: "pointer",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('set-answered', props.message.Id)), ["stop"]))
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass({
							'body-message__text': true,
							'body-message__text--is-system': props.message.IsSystem
						}),
          innerHTML: props.message?.Text.replaceAll('\n', '<br>')
        }, null, 10, _hoisted_9),
        (props.message.AttachedMessages?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.message.AttachedMessages, (aMessage) => {
                return (_openBlock(), _createBlock(ChatMessageAttached, {
                  "attached-message": aMessage,
                  key: aMessage.Id
                }, null, 8, ["attached-message"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 10, _hoisted_1))
}
}

})